import React from 'react'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import Question from 'components/consult/create-consult/Question'
import Purchase from 'components/consult/create-consult/Purchase'
import Loading from 'components/Loading'
import TermsAndConditionModal from 'components/TermsAndConditionModal'
import utils from 'Utils'
import axios from 'axios'
import Matrix from 'scripts/Matrix'
import store from 'scripts/store'
import { Redirect } from 'react-router-dom'


const STEP_QUESTION = 1
const STEP_PURCHASE = 2

const DESC_QUESTION = 'پرسش سوال'
const DESC_PURCHASE = 'انتخاب بخش مشاوره'

class CreateConsult extends React.Component {
    constructor(props) {
        super(props)

        let categoryId, question

        if (window.localStorage.getItem('questionFromBlog')) {
            const questionFromBlog = JSON.parse(window.localStorage.getItem('questionFromBlog'))

            categoryId = questionFromBlog.categoryId
            question = questionFromBlog.question
        }

        this.state = {
            headerDesc: DESC_QUESTION,
            step: STEP_QUESTION,
            redirect: '',
            consultCategory: {},
            consultRequest: {},
            sendLoading: false,
            type: this.props.location.state.type || 'text',
            loading: false,
            data: {
                consultRequestId: '',
                question: question ? question : '',
                ConsultCategoryId: categoryId ? categoryId : props.location.state && props.location.state.consultCategory && props.location.state.consultCategory.id,
                callback: utils.urls.askQuestionCallbackURL
            },
            wallet: {},
            textArray: [],
            firstConsultCode: ''
        }
    }

    async componentDidMount() {

        if (this.props.location.state && this.props.location.state.consultRequest) {
            this.setState({
                step: STEP_PURCHASE,
                consultRequest: this.props.location.state.consultRequest,
                consultCategory: this.props.location.state.consultRequest.ConsultCategory ? this.props.location.state.consultRequest.ConsultCategory : this.props.location.state.consultRequest,
                data: {
                    ...this.state.data,
                    consultRequestId: this.props.location.state.consultRequest.id,
                    question: this.props.location.state.consultRequest.question,
                    consultCategoryId: this.props.location.state.consultRequest.ConsultCategoryId,
                }
            })
        }

        const wallet = await store.getWallet()
        this.setState({ wallet })

        if (window.localStorage.getItem('questionFromBlog')) this.initAsk()

        this.getFirstTextOfChat()
    }

    onBack = () => {
        if (this.state.step === STEP_QUESTION) window.history.back()
        if (this.state.step === STEP_PURCHASE) this.setState({ step: STEP_QUESTION })
    }

    openSnackbar = (message, type = 'error') => this.SnackBar.openSnackbar(message, type)

    openTermsAndConditionModal = () => this.TermsAndConditionModal.openModal()

    changeStep = step => this.setState({ step })

    getFirstTextOfChat = () => {
        let doctorFullName, exp, category
        let ConsultCategory, doctor
        let avgResponse = 12

        let textArray = [
//             `تماس با پشتیبانی ازمسیرهای زیر امکان پذیر است:
// تلفن(پاسخگویی بین ساعات ۹ تا ۱۸):
// 02171148100
// واتساپ(پاسخگویی بین ساعات ۹ تا ۱۸):
// 09044711480 - 09012175046`
            // `لطفا برای شروع مکالمه و گفتگو سوال خود را داخل کادر پایین نوشته و برای من ارسال کنید، تلاش میکنم تا ${avgResponse} ساعت آینده پاسخ شما را بدهم`,
            // `بعد از شروع مکالمه، شما امکان ارسال جواب آزمایش یا عکس های پزشکی و پیام صوتی را هم خواهید داشت`
        ]

        if (this.props.location.state && this.props.location.state.consultCategory) // if in edit consult
            this.setState({ consultCategory: this.props.location.state.consultCategory })
        else if (this.props.location.state && this.props.location.state.doctor) // in new consult
            doctor = this.props.location.state.doctor

        if (doctor) {
            doctorFullName = doctor.fname + ' ' + doctor.lname

            exp = doctor.expUnis?.length ?
                doctor.expUnis[0].expertise.name :
                doctor.spUnis?.length && doctor.spUnis[0] ?
                    doctor.spUnis[0].specialty.name : ''

            avgResponse = doctor.DoctorConsultInfo?.avgResponse || 12

            if (this.props.location.state.type === 'voice')
                textArray = [
                    `سلام دکتر ${doctorFullName} هستم${exp && ' متخصص ' + exp}`,
                    'از ساعت 8 تا 24 پاسخگو هستم و حداکثر تا 12 ساعت پاسخ شما را خواهم داد، ارسال عکس و نتیجه آزمایش بعد از شروع گفتگو امکان پذیر است. در صورت عدم پذیرش، وجه پرداختی به کیف پول شما در طبینجا بازگشت داده می شود. حداکثر زمان گفتگوی تلفنی 15 دقیقه است.',
                    `برای بررسی دقیق تر، به سوالات زیر پاسخ دهید و منتظر تعیین ساعت تماس از طرف من باشید.

1-سن شما چقدر است؟
2-چه داروهایی مصرف می کنید؟
3-سابقه بیماری و دلیل درخواست مشاوره را بنویسید.`,
                    'نتیجه درخواست شما از طریق پیامک به شما اطلاع رسانی می شود.',
                    ...textArray
                ]

            if (this.props.location.state.type === 'video')
                textArray = [
                    `سلام دکتر ${doctorFullName} هستم${exp && ' متخصص ' + exp}`,
                    'از ساعت 8 تا 24 پاسخگو هستم و حداکثر تا 12 ساعت پاسخ شما را خواهم داد، ارسال عکس و نتیجه آزمایش بعد از شروع گفتگو امکان پذیر است. در صورت عدم پذیرش، وجه پرداختی به کیف پول شما در طبینجا بازگشت داده می شود. حداکثر زمان تماس تصویری 15 دقیقه است.',
                    `برای بررسی دقیق تر، به سوالات زیر پاسخ دهید و منتظر تعیین ساعت تماس از طرف من باشید.

1-سن شما چقدر است؟
2-چه داروهایی مصرف می کنید؟
3-سابقه بیماری و دلیل درخواست مشاوره را بنویسید.`,
'نتیجه درخواست شما از طریق پیامک به شما اطلاع رسانی می شود.',
                    ...textArray
                ]

            if (this.props.location.state.type === 'text')
                textArray = [
                    `سلام دکتر ${doctorFullName} هستم${exp && ' متخصص ' + exp}`,
                    'از ساعت 8 تا 24 پاسخگو هستم و حداکثر تا 12 ساعت پاسخ شما را خواهم داد، ارسال عکس و نتیجه آزمایش بعد از شروع گفتگو امکان پذیر است. در صورت عدم پذیرش، وجه پرداختی به کیف پول شما در طبینجا بازگشت داده می شود.',
                    `برای بررسی دقیق تر، به سوالات زیر پاسخ دهید:

1-سن شما چقدر است؟
2-چه داروهایی مصرف می کنید؟
3-سابقه بیماری و دلیل درخواست مشاوره را بنویسید.`,
'نتیجه درخواست شما از طریق پیامک به شما اطلاع رسانی می شود.',
                    ...textArray
                ]

            // textArray = [
            //     `سلام دکتر ${doctorFullName} هستم${exp && ' متخصص ' + exp}`,
            //     ...textArray
            // ]
        } else {
            category = this.state.consultCategory.name

            textArray = [
                `سلام، شما در حال مکالمه با یکی از پزشکان تخصص ${category} هستید`,
                'از ساعت 8 تا 24 پاسخگو هستم و حداکثر تا 12 ساعت پاسخ شما را خواهم داد، ارسال عکس و نتیجه آزمایش بعد از شروع گفتگو امکان پذیر است. در صورت عدم پذیرش، وجه پرداختی به کیف پول شما در طبینجا بازگشت داده می شود.',
                    `برای بررسی دقیق تر، به سوالات زیر پاسخ دهید:

1-سن شما چقدر است؟
2-چه داروهایی مصرف می کنید؟
3-سابقه بیماری و دلیل درخواست مشاوره را بنویسید.`,
'نتیجه درخواست شما از طریق پیامک به شما اطلاع رسانی می شود.',
                    ...textArray
                ]
        }

        this.setState({ textArray })
    }


    onTextInputHandle = e => this.setState({
        data: {
            ...this.state.data, question: e.target.value
        }
    })

    gotoPurchase = async () => {
        if (this.state.data.question.length <= 60) return this.SnackBar.openSnackbar('متن سوال بیش از 60 حرف باشد')

        await this.initAsk(this.state.type)

        this.isFirstConsult()
    }

    initAsk = async type => {
        this.setState({ sendLoading: true })
        // TODO Ask with quiz
        // let url = this.state.data.ConsultRequestId ? utils.urls.consultAskQuestionWithQuiz : utils.urls.askinit 

        let params = { ...this.state.data, type }

        if (this.props.location.state && this.props.location.state.doctor) {
            params = {
                ...this.state.data,
                doctorId: this.props.location.state.doctor.id,
                type
            }
        }

        const res = await axios.post(utils.urls.initAsk, params, {
            headers: {
                'x-access-token': Matrix.getToken()
            }
        })
            .catch((e) => {
                console.log(e)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.SnackBar.openSnackbar(message)
            })

        this.setState({ sendLoading: false })

        if (!res) return
        if (!res.data.success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

        const { chargeWalletUrl, consultRequest } = res.data

        this.setState({
            step: STEP_PURCHASE,
            consultRequest: consultRequest,
            consultCategory: { price: consultRequest.price },
            data: { ...this.state.data, question: consultRequest.question }
        })

        window.localStorage.removeItem('questionFromBlog')
    }

    isFirstConsult = async () => {
        let res = await axios.post(utils.urls.isFirstConsult, {}, {
            headers: {
                'x-access-token': Matrix.getToken()
            }
        }).catch((e) => {
            console.log(e)
        })

        if (!res) return

        const { success, code } = res.data

        if (success) this.setState({ firstConsultCode: code })
    }

    finalizePay = async () => {
        this.setState({ loading: true })

        // let url = this.state.data.ConsultRequestId ? utils.urls.consultAskQuestionWithQuiz : utils.urls.consultNewAskQuestion
        const url = utils.urls.finalizeAsk
        const { consultRequest, data: { callback } } = this.state

        let res = await axios.post(url, {
            consultRequestId: consultRequest.id,
            callback: callback
        }, {
            headers: {
                'x-access-token': Matrix.getToken()
            }
        })
            .catch((e) => {
                console.log(e.response)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.SnackBar.openSnackbar(message)
            })

        this.setState({ loading: false })

        if (!res) return
        if (!res.data.success) return this.SnackBar.openSnackbar('مشکلی پیش آمده است')

        console.log(res.data, 'data')

        if(res.data.consultRequest.status === 'asked'){
            this.SnackBar.openSnackbar('ثبت پرسش موفقیت آمیز بود', 'info')
            this.setState({ loading: true })
            setTimeout(() => {
                this.setState({ redirect: '/chats' })
                this.setState({ loading: false})
            }, 5000)
            return
        }

        const params = Object.keys(res.data.chargeWalletResult.params)
        const values = Object.values(res.data.chargeWalletResult.params)

        document.getElementById('atipay').innerHTML = ''

        for(let i = 0; i<params.length; i++) {
            document.getElementById('atipay').innerHTML += `<input type="hidden" value="${values[i]}" name="${params[i]}"/>`
        }

        document.getElementById('atipay').submit()

    }

    render() {
        if (this.state.redirect) return <Redirect to={this.state.redirect} push />

        return (
            <>
                <Header title="درخواست مشاوره" desc={this.state.headerDesc} onBack={this.onBack} showBackButton />
                <div className="page-root">
                    {this.state.step === STEP_QUESTION &&
                        <Question
                            textArray={this.state.textArray}
                            question={this.state.data.question}
                            sendLoading={this.state.sendLoading}
                            handleChange={this.onTextInputHandle}
                            gotoPurchase={this.gotoPurchase}
                            openSnackbar={this.openSnackbar}
                        />
                    }

                    {this.state.step === STEP_PURCHASE &&
                        <Purchase
                            consultRequest={this.state.consultRequest}
                            consultCategory={this.state.consultCategory}
                            openSnackbar={this.openSnackbar}
                            changeStep={this.changeStep}
                            wallet={this.state.wallet}
                            finalizePay={this.finalizePay}
                            openTermsAndConditionModal={this.openTermsAndConditionModal}
                        />
                    }
                    {this.state.loading && <Loading />}
                </div>
                <SnackBar ref={el => this.SnackBar = el} />
                <TermsAndConditionModal ref={el => this.TermsAndConditionModal = el} />
                <form name="myForm" id="atipay" action="https://mipg.atipay.net/v1/redirect-to-gateway" method="POST"></form>
            </>
        )
    }
}

export default CreateConsult
